import { useQuery } from '@tanstack/react-query';
import { get } from '../api/client.js';

export function useAuditLog({ action, limit = 100 } = {}) {
  return useQuery({
    queryKey: ['audit', action || 'all', limit],
    queryFn: async () => {
      const q = new URLSearchParams();
      q.set('limit', String(limit));
      if (action) q.set('action', action + '*');
      return (await get('/api/audit?' + q.toString())).entries || [];
    },
    staleTime: 15_000,
  });
}
